import React from "react";
import { createContext, useReducer } from "react";
import PropTypes from "prop-types";

const initialState = {
  selectedCard: null,
  userHasDragged: false,
};

const dispatch = () => null;

export const ProductsContext = createContext({
  state: initialState,
  dispatch,
});

const { Provider } = ProductsContext;

export const Actions = {
  SET_SELECTED_CARD: "SET_SELECTED_CARD",
  SET_USER_HAS_DRAGGED: "SET_USER_HAS_DRAGGED",
};

const reducer = (state, action) => {
  switch (action.type) {
    case Actions.SET_SELECTED_CARD:
      return { ...state, selectedCard: action.payload };
    case Actions.SET_USER_HAS_DRAGGED:
      return { ...state, userHasDragged: action.payload };
    default:
      return state;
  }
};

export const ProductsContextProvider = ({ children }) => {
  const startState = { ...initialState };
  const [state, dispatch] = useReducer(reducer, startState);
  const value = { state, dispatch };
  return <Provider value={value}>{children}</Provider>;
};

ProductsContextProvider.propTypes = {
  children: PropTypes.node,
};
